import {MaxiDingConfig} from "../configuration/configurations";

export const getAge = () => {
    return fetch(MaxiDingConfig.getAge, {
        method: 'GET',
        headers: {},
    });
}